import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import 'reflect-metadata';
import { IntensiveRoutes } from "./Intensive/routes";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <IntensiveRoutes />
    </BrowserRouter>
  </React.StrictMode>
);
